import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
import _imports_0 from '../../images/web-icon.png';
import _imports_1 from '../../images/answer-loading.gif';
const _hoisted_1 = {
  class: "content-block p-4 mt-3"
};
const _hoisted_2 = {
  class: ""
};
const _hoisted_3 = {
  class: "mt-2 max-h-[200px] overflow-y-auto pr-2"
};
const _hoisted_4 = {
  class: "max-w-[450px] truncate"
};
const _hoisted_5 = {
  key: 0,
  class: "h-3"
};
const _hoisted_6 = {
  key: 1,
  class: "status"
};
import { ref, onMounted, onUnmounted, computed } from 'vue';
import useMainStore, { storeToRefs } from '@views/main/main.store';
import { assessNodeTaskRestart } from '@views/main/api';
import FoldBox from '../FoldBox.vue';
import initIncrementalUpdate from './mixins/incrementalUpdate.mixin';
export default /*@__PURE__*/_defineComponent({
  __name: 'ContentScraping',
  props: {
    item: {},
    content: {}
  },
  setup(__props) {
    const props = __props;
    const mainStore = useMainStore();
    const {
      messageContentMap,
      incrementalMessageList
    } = storeToRefs(mainStore);
    const foldBoxRef = ref();
    const isCustom = ref(false); // 判断用户是否自行操作展开收起了
    const info = ref({
      links: []
    });
    const messageContent = ref([]);
    const viewIns = ref(0); // 当前正在浏览的索引
    const totalViewed = computed(() => {
      return messageContent.value.filter(x => x.status === 3).length || 1;
    });
    const showTitle = computed(() => {
      if (info.value.executeStatus === 3) {
        const count = messageContent.value.filter(x => x.status === 3).length || 1;
        const pageNum = info.value.links?.length || 1;
        return `任务2：浏览任务已完成，本次发现${pageNum}个页面，完成浏览${count}个页面`;
      }
      return ` 任务2：发现${info.value.links?.length || 1}个页面，正在浏览第 ${totalViewed.value}个网址[
      ${info.value.links?.[viewIns.value]}]`;
    });
    const handleRestart = async () => {
      try {
        await assessNodeTaskRestart({
          sessionId: mainStore.msgParams.sessionId,
          taskNode: props.item.messageType
        });
        info.value.executeStatus = 1;
      } catch (error) {
        console.log(error);
      }
    };
    const handleStatus = url => {
      const item = messageContent.value.find(x => x.url === url);
      if (info.value.executeStatus === 3) {
        return item?.status === 3 ? '完成浏览' : '浏览失败';
      }
      if (item) {
        switch (item.status) {
          case 2:
            return '完成浏览';
          case 3:
            return '完成浏览';
          default:
            return '浏览中';
        }
      } else {
        return info.value.executeStatus === 2 ? '浏览失败' : '待浏览';
      }
    };
    const {
      handleIncrementalMessage
    } = initIncrementalUpdate(async message => {
      const incrementalData = message.incrementalData;
      if (incrementalData.data) {
        const item = {
          url: incrementalData.url,
          status: incrementalData.success ? 3 : 2,
          content: JSON.stringify(incrementalData.data || {}),
          messageId: message.id
        };
        messageContent.value.push(item);
        if (incrementalData.done) {
          setTimeout(() => {
            info.value.executeStatus = 3;
            mainStore.loadNextMsg(props.item);
          }, 1000);
        }
        if (info.value.links) {
          const index = info.value.links.findIndex(x => x === item.url);
          viewIns.value = index > -1 ? index : 0;
        }
      }
    });
    onUnmounted(() => {
      mainStore.componentFunMap.delete(props.item.id);
    });
    onMounted(() => {
      if (props.item.id) {
        mainStore.componentFunMap.set(props.item.id, handleIncrementalMessage);
      }
      try {
        if (props.content) info.value = props.content;
        messageContent.value = messageContentMap.value[props.item.id] || [];
        // 新增消息的时候这里
        if (props.item.openAnimate && !isCustom.value) foldBoxRef.value?.setIsFold(true);
        // 处理增量数据
        if (props.item.incrementalIds) {
          props.item.incrementalIds.forEach(id => {
            handleIncrementalMessage(incrementalMessageList.value[id]);
          });
        }
      } catch (error) {
        info.value = {
          links: []
        };
        console.log(error);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_link = _resolveComponent("el-link");
      return _openBlock(), _createBlock(FoldBox, {
        ref_key: "foldBoxRef",
        ref: foldBoxRef,
        id: props.item.id,
        status: info.value.executeStatus || 1,
        onChange: _cache[0] || (_cache[0] = $event => isCustom.value = true),
        onRestart: handleRestart
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(showTitle.value), 1)]),
        default: _withCtx(() => [_cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "tool-block pl-3 py-[10px]"
        }, [_createElementVNode("div", {
          class: "flex items-center"
        }, [_createElementVNode("img", {
          src: _imports_0,
          alt: "web",
          class: "w-5 h-5"
        }), _createElementVNode("div", {
          class: "ml-1 text-[#4E5969] text-sm"
        }, "正在使用网页工具：Web Tools")])], -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "label"
        }, "获取到以下链接：", -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.value.links, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item,
            class: "flex items-center justify-between"
          }, [_createVNode(_component_el_link, {
            type: "primary",
            href: item,
            target: "_blank"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_4, _toDisplayString(item), 1)]),
            _: 2
          }, 1032, ["href"]), handleStatus(item) === '浏览中' || handleStatus(item) === '待浏览' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[1] || (_cache[1] = [_createElementVNode("img", {
            src: _imports_1,
            class: "w-6",
            alt: ""
          }, null, -1)]))])) : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(handleStatus(item)), 1))]);
        }), 128))])])])]),
        _: 1
      }, 8, ["id", "status"]);
    };
  }
});